// extracted by mini-css-extract-plugin
module.exports = {"shimmer":"Shimmer_shimmer__pU3gS","top":"Shimmer_top__vqNDC","bottom":"Shimmer_bottom__vKD0G","subtitle":"Shimmer_subtitle__1kOgA"};